import React, { ReactElement, ReactNode, useEffect } from 'react';
import { connect } from 'react-redux';
import { useAdPositionElements, insertBanners } from '@schibsted-nmp/advertising-companion';

import { trackResultPage } from '../tracking/FinnAnalytics';

import { SpinnerIcon } from 'shared/icons/SpinnerIcon';

import { ApiActionStatus, Filters, PaleState, Results } from '../../interfaces';
import { ResultListItem } from './ResultListItem';
import ResultEmptyWarning from '@/components/emptyWarning/ResultEmptyWarning';
import { SortDetailsLink } from '@/components/resultList/SortDetailsLink';

interface Props {
    results: Results;
    filters: Filters;
}

export const ResultList: React.FC<Props> = ({ results, filters }): ReactElement<Props> => {
    const [bannerPositions, bannerElements] = useAdPositionElements({
        cols: 1,
        type: 'search',
    });

    useEffect(() => {
        trackResultPage(results, filters);
    }, [results.offers]); // Only trigger new tracking when the list of offers changes

    const resultList = results.offers.map((offer): ReactNode => <ResultListItem key={offer.offerId} offer={offer} filters={filters} />);

    const resultListWithBanners = insertBanners({
        adItems: resultList,
        bannerPositions,
        bannerElements,
    });

    return (
        <section id="resultList" data-testid="resultList" className="ads u-ml0 u-mr0 u-position-relative">
            <SortDetailsLink />
            {results.offers.length <= 0 && <ResultEmptyWarning />}
            {resultListWithBanners}
            {results.status === ApiActionStatus.PENDING && (
                <div data-testid="resultListOverlay" className="overlay u-bg-milk u-text-center u-opacity075" title="Laster nye tilbud">
                    <SpinnerIcon className="spinner" />
                </div>
            )}
        </section>
    );
};

const mapStateToProps = (state: PaleState): Props => ({
    results: state.results,
    filters: state.filters,
});

export default connect(mapStateToProps)(ResultList);
